import request from '../utils/request'

export function getAdminRoles() {
  return request({
    url: '/api/admin/roles',
    method: 'get'
  })
}

export function createAdminRole(data) {
  return request({
    url: '/api/admin/roles',
    method: 'post',
    data
  })
}

export function updateAdminRole(id, data) {
  return request({
    url: `/api/admin/roles/${id}`,
    method: 'put',
    data
  })
}

export function saveRolePermissions(id, data) {
  return request({
    url: `/api/admin/roles/${id}/permissions`,
    method: 'post',
    data
  })
}

export function getRolePermissionIds(id) {
  return request({
    url: `/api/admin/roles/${id}/permissions`,
    method: 'get'
  })
}
